import { render, staticRenderFns } from "./OrderUpdateProductSearch.vue?vue&type=template&id=036cbf4c"
import script from "./OrderUpdateProductSearch.vue?vue&type=script&lang=js"
export * from "./OrderUpdateProductSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports